import React from 'react'
import ErgoStyleProvider from '@eg/elements/Provider'
import Header from './Header'
import DemoHeader from './DemoHeader'
import Footer from './Footer'

require('./layout.scss')

const DefaultLayout = ({
  children,
  user,
  oauthConfig,
  displayLoginInHeader,
}) => {
  const isDemoVersion = window.location.host.split(/\.|-/).includes('demo');
  return (
    <ErgoStyleProvider theme="ergo">
      {isDemoVersion && <DemoHeader />}
      <div className={`layout-container ${isDemoVersion ? 'demo' : ''}`}>
        <Header
          user={user}
          oauthConfig={oauthConfig}
          displayLoginInHeader={displayLoginInHeader}
        />
        <main>{children}</main>
        <Footer />
      </div>
    </ErgoStyleProvider>
  )
}

export default DefaultLayout
